<template lang="pug">
  .b2b-page-genrals-emits
    ods-module.box-card
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('msg_generics.information') }}
          ods-col(:span='16')
            ods-row(type='flex', justify='end')
              ods-tooltip(:content='$t("genral.genral_detail.download_pdf_buttons_tooltip")', placement='bottom')
                  ods-button(
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='handleDownloadGenralPdf')
                    | {{ $t('genral.genral_detail.download_pdf_buttons') }}
      ods-form(
        ref='genralDetailForm',
        :model='genralDetailForm',
        label-width='14rem',
        label-position='top',
        size='small',
        status-icon)
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              prop='sellerName',
              :label='$t("genral.genral_entity_table.seller")')
              ods-input(
                :disabled='true',
                v-model='genralDetailForm.sellerName')
            ods-form-item(
              prop='genralNumber',
              :label='$t("genral.genral_entity_table.num_genral")')
              ods-input(
                :disabled='true',
                v-model='genralDetailForm.genralNumber')
            ods-form-item(
              prop='creationDateTime',
              :label='$t("genral.genral_entity_table.date_creation")')
              ods-input(
                :disabled='true',
                v-model='creationDateTimeFormatted')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              prop='buyerName',
              :label='$t("genral.genral_entity_table.buyer")')
              ods-input(
                :disabled='true',
                v-model='genralDetailForm.buyerName')
            ods-form-item(
              prop='statusId',
              :label='$t("genral.genral_entity_table.status")')
              ods-input(
                :disabled='true',
                v-model='genralDetailForm.statusId')
            ods-form-item(
              prop='issueDateTime',
              :label='$t("genral.genral_entity_table.date_issue")')
              ods-input(
                :disabled='true',
                v-model='issueDateTimeFormatted')
          ods-col(:span='24')
            ods-form-item(
              prop='description',
              :label='$t("genral.genral_entity_table.description")')
              ods-input(
                type='textarea',
                :autosize='true'
                :disabled='true',
                v-model='genralDetailForm.description')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bTimeline from '@/components/B2bTimeline'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-genrals-emits',
  mixins: [Utils],
  data () {
    return {
      statusDocumentGenral: null,
      genralStatus: null,
      searchType: 'EMITTED',
      genralDetailForm: {
        buyerName: null,
        sellerName: null,
        genralNumber: null,
        issueDateTime: '',
        creationDateTime: '',
        documentStatus: null,
        projectName: null,
        statusId: null,
        description: null
      },
      viewUpdate: false,
      currentRow: {}
    }
  },

  components: {
    B2bTimeline
  },

  computed: {
    ...mapGetters([
      // Permisos
      'canChangeStatusGenral'
    ]),

    issueDateTimeFormatted () { // eslint-disable-line
      if (this.genralDetailForm.issueDateTime) {
        const date = moment(this.genralDetailForm.issueDateTime)
        return date.format(this.$t('date_format'))
      }
    },

    creationDateTimeFormatted () { // eslint-disable-line
      if (this.genralDetailForm.creationDateTime) {
        const date = moment(this.genralDetailForm.creationDateTime)
        return date.format(this.$t('date_format_long'))
      }
    }
  },

  methods: {
    ...mapActions([
      'getGenralDetail',
      'downloadGenralPdf'
    ]),

    formatterStatus (row, column) {
      return row.status != null ? this.$t('genral_status.' + row.status) : null
    },
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },
    // Descarga de pdf
    async handleDownloadGenralPdf () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })
      try {
        const params = {
          genralId: this.$route.params.genralId,
          searchType: this.searchType
        }
        const filename = await this.downloadGenralPdf(params)
        this.$notify({
          title: this.$t('genral.genral_detail.notify.download_pdf', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Detalle genral
    async getGenralsEmitOnDatabase () {
      try {
        this.genralDetailForm = await this.getGenralDetail({
          genralID: this.$route.params.genralId,
          searchType: this.searchType
        })
        // Guardamos estado
        this.genralStatus = this.genralDetailForm.statusId
        this.statusDocumentGenral = this.genralDetailForm.documentStatus
        // Formateamos estado
        if (this.genralStatus != null && this.genralStatus === 'REJECTED' && this.genralDetailForm.rejectSeller) {
          const REJECTED_SELLER = 'REJECTED_SELLER'
          this.genralDetailForm.statusId = this.$t('genral_status.' + REJECTED_SELLER)
        } else {
          this.genralDetailForm.statusId = this.$t('genral_status.' + this.genralDetailForm.statusId)
          console.log(this.genralDetailForm)
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 403:
          errorSms = this.$t('error.e403')
          break
        case 404:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = this.$t('error.e500')
          break
        default:
          errorSms = this.$t('error.default')
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      // Detalle genral
      await this.getGenralsEmitOnDatabase()
    } catch (error) {
      console.log('created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-genrals-emits {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module{
    &__header{
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info{
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }
    }
  }

  .form-actions{
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button{
      float: right;
    }
  }

  .ods-button:not(.is-circle) i, .ods-button:not(.is-circle) [class*="ods-icon-"], .ods-button:not(.is-circle) [class*=" ods-icon-"] {
      margin-top: -2px;
      margin-left: 0px;
  }
  .collapse{
    margin-top: 25px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    ::v-deep .ods-table{
      th {
        padding: rem(0);
        padding-top: rem(4);

        .cell {
          font-weight: 500;
        }
      }
      &__row{
        .ods-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: 0px;
          i {
            margin-left: 0px;
          }
        }
        .first-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: rem(12);
          i {
            margin-left: 0px;
          }
        }
      }
      ::v-deep .ods-button{
      background-color: #FFF;
      border-color: #FFF;
      color: #000;
      }
      ::v-deep .ods-input-number .ods-input__inner {
        padding: 4px 30px 4px 8px;
        text-align: right;
      }
    }
    ::v-deep .ods-input.is-disabled .ods-input__inner{
      background-color: transparent;
      border-color: transparent;
      color: black;
      cursor: not-allowed;
      text-align: right;
    }

    .button-collapse {
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
  }
}
</style>
